<app-aggregated-amount-item
  [name]="(selectedArtist$ | async)?.nameMain"
  icon="./assets/stream_line.png"
  amount="{{ (lineFollower$ | async)?.units }}"
  unit="フォロワー数"
  [rate]="(lineFollower$ | async)?.rate"
  [link]=""
  [hasAmount]="(lineFollower$ | async)?.hasUnits"
  [loading]="loading$ | async"
  help="選択期間内に取得できた最新のLINEのアーティストフォロワー数を表示しています。"
  [dataCollections]="dataCollections$ | async"
  [dataCollectLoading]="dataCollectLoading$ | async"
  [isDecimal]="true"
></app-aggregated-amount-item>
